import { useMemo } from "react";

import { Label } from "../VersionTab/types";

import type { VersionSelectorVersion } from "@/components/VersionSelector/types";

const useOptimisticVersions = (
  versions: VersionSelectorVersion[] | undefined,
  pendingLabelMoves: Record<
    string,
    {
      sourceVersionId: number | string;
      targetVersionId: number | string;
      label: Label;
    }
  >,
) => {
  const augmentedVersions = useMemo(() => {
    if (!versions || Object.keys(pendingLabelMoves).length === 0) {
      return versions ?? [];
    }

    const nextVersions = structuredClone(versions);

    Object.values(pendingLabelMoves).forEach(({ sourceVersionId, targetVersionId, label }) => {
      const sourceVersionIndex = nextVersions.findIndex(v => v.id === sourceVersionId);
      const targetVersionIndex = nextVersions.findIndex(v => v.id === targetVersionId);

      if (sourceVersionIndex >= 0 && targetVersionIndex >= 0) {
        const sourceVersion = nextVersions[sourceVersionIndex];
        sourceVersion.labels = sourceVersion.labels.filter((l: Label) => l.id !== label.id);

        const targetVersion = nextVersions[targetVersionIndex];
        if (!targetVersion.labels.some((l: Label) => l.id === label.id)) {
          targetVersion.labels.push(label);
        }
      }
    });

    return nextVersions;
  }, [pendingLabelMoves, versions]);

  return { augmentedVersions };
};

export default useOptimisticVersions;
